import { render, staticRenderFns } from "./PartslistviewPage.vue?vue&type=template&id=463d49c5"
import script from "./PartslistviewPage.vue?vue&type=script&lang=js"
export * from "./PartslistviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports